import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_MATERIAS = 'ALL_MATERIAS';
export const LOADING_ALL_MATERIAS = 'LOADING_ALL_MATERIAS';
export const ACTIVO_MATERIAS = 'ACTIVO_MATERIAS';
export const PARAMS_MATERIAS = 'PARAMS_MATERIAS';

const initialState = {
  all: [],
  loadingAll: false,
  activo: null,
  params: {},
};

export const materiasReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_MATERIAS:
      return {
        ...state,
        all: action.payload.data,
        meta: action.payload.meta,
      };
    case LOADING_ALL_MATERIAS:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case ACTIVO_MATERIAS:
      return {
        ...state,
        activo: action.payload,
      };
    case PARAMS_MATERIAS:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
